import { render, staticRenderFns } from "./MainSliderForDecanat.vue?vue&type=template&id=3d227a1a&scoped=true&"
import script from "./MainSliderForDecanat.vue?vue&type=script&lang=js&"
export * from "./MainSliderForDecanat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d227a1a",
  null
  
)

export default component.exports